import React from 'react'
import BaseComponent from '../../../common/base';
import { Card, Button } from 'react-bootstrap';
import QuestionnairePartialCard from '../../partials/card';
import coverPhoto from '../../../../assets/images/ideas3x.png'
import fsc from '../../../common/fullscreen';

export class StepPreparationFullscreen extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = Object.assign(
            this.state,
            {
                wasFullScreenSet: false,
                isInFullScreen: false
            }
        )

        this.handleFullScreen = this.handleFullScreen.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        window.addEventListener("APP_FULLSCREEN", this.handleFullScreen, false);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener("APP_FULLSCREEN", this.handleFullScreen, false);
    }

    handleFullScreen(data) {
        let isInFullScreen = data.detail ? true : false;
        this.setState({ isInFullScreen: isInFullScreen });
    }

    openFullscreen() {
        fsc.openFullscreen();
        this.setState({ isInFullScreen: true, wasFullScreenSet: true });
    }

    closeFullscreen() {
        fsc.closeFullscreen();
        this.setState({ isInFullScreen: false, wasFullScreenSet: true });
    }

    render() {

        const bodyInitial = (
            <>
                <Card.Text>
                    {this.t('questionnaire.preparation.fullscreen.text.01')}
                </Card.Text>
                <Card.Text>
                    {this.t('questionnaire.preparation.fullscreen.text.02')}
                </Card.Text>
                <Button variant="primary" onClick={(e) => { this.openFullscreen() }}>
                    {this.t('questionnaire.preparation.fullscreen.enter')}
                </Button>
            </>
        );

        const bodyAfterInteraction = (
            <>
                <Card.Text>
                    {this.t('questionnaire.preparation.fullscreen.text.01')}
                </Card.Text>
                <Card.Text>
                    {this.t('questionnaire.preparation.fullscreen.text.03')}
                </Card.Text>
                <Button variant="primary" onClick={(e) => { this.props.nextStep() }}>
                    {this.t('questionnaire.common.nextStep')}
                </Button>
                {
                    this.state.isInFullScreen
                        ?
                        (
                            <Button
                                className="mt-3"
                                variant="secondary"
                                onClick={(e) => { this.closeFullscreen() }}>
                                {this.t('questionnaire.preparation.fullscreen.exit')}
                            </Button>
                        )
                        :
                        (
                            <Button
                                className="mt-3"
                                variant="success"
                                onClick={(e) => { this.openFullscreen() }}>
                                {this.t('questionnaire.preparation.fullscreen.enter')}
                            </Button>
                        )
                }
            </>
        );

        let currentBody = bodyInitial;
        if (this.state.wasFullScreenSet) {
            currentBody = bodyAfterInteraction;
        }

        return (
            <>
                <QuestionnairePartialCard
                    img={coverPhoto}
                    title={this.t('questionnaire.preparation.fullscreen.title')}
                    body={currentBody}
                    footer={
                        <>
                            <Button
                                variant="light"
                                className="float-right"
                                onClick={(e) => this.props.nextStep(e)}
                            >
                                {this.t('questionnaire.common.skip')}
                            </Button>
                        </>
                    }
                />
            </>
        )
    }

}

export default StepPreparationFullscreen;